export enum CreditFrequency {
    WEEK = 'WEEK',
    MONTH = 'MONTH',
}
